import { render } from "./PersonSearch.vue?vue&type=template&id=055179aa&lang=pug"
import script from "./PersonSearch.vue?vue&type=script&lang=js"
export * from "./PersonSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__